import { createSelector } from 'reselect';
import { RootState } from 'MyTypes';

const loadingOverlayStore = (state: RootState) => state.loadingOverlay;

export const selectShowLoadingOverlay = createSelector(loadingOverlayStore, (store) => store?.show);

export default selectShowLoadingOverlay;
